import dayjs from "dayjs";

export const CURRENCY_SYMBOLS = { NGN: "₦", GBP: "£", EUR: "€", ZAR: "R", GHS: "₵", USD: "$" };

export const money = (amount, currency = "NGN") => {
  const sym = CURRENCY_SYMBOLS[currency] || "";
  const n = Number(amount || 0);
  return `${sym}${n.toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
};

export const fmtDate = (d) => (d ? dayjs(d).format("DD MMM YYYY") : "—");
export const fmtDateTime = (d) => (d ? dayjs(d).format("DD MMM YYYY, HH:mm") : "—");
export const fmtTime = (d) => (d ? dayjs(d).format("HH:mm") : "—");
export const timeAgo = (d) => {
  if (!d) return "—";
  const diff = dayjs().diff(dayjs(d), "minute");
  if (diff < 1) return "just now";
  if (diff < 60) return `${diff}m ago`;
  if (diff < 1440) return `${Math.floor(diff / 60)}h ago`;
  return dayjs(d).format("DD MMM");
};

export const initials = (name = "") =>
  name.trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("") || "?";

export const titleCase = (s = "") =>
  String(s).replace(/[_-]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const JURISDICTIONS = [
  { code: "NG", name: "Nigeria", flag: "🇳🇬", currency: "NGN" },
  { code: "GB", name: "United Kingdom", flag: "🇬🇧", currency: "GBP" },
  { code: "IE", name: "Ireland", flag: "🇮🇪", currency: "EUR" },
  { code: "ZA", name: "South Africa", flag: "🇿🇦", currency: "ZAR" },
  { code: "GH", name: "Ghana", flag: "🇬🇭", currency: "GHS" },
];
